import {
	AccountBalanceWallet as AccountBalanceWalletIcon,
	Assignment as AssignmentIcon,
	Home as HomeIcon,
	LocalOffer as LocalOfferIcon,
	LocalShipping as LocalShippingIcon,
	Face as FaceIcon,
	Storefront as StorefrontIcon,
	Business as BusinessIcon,
	ShoppingCart,
	Settings,
	Build,
	ListAlt,
	Assessment as AssessmentIcon,
	PlaylistAddCheck as FactCheckIcon,
	HomeWork as HomeWorkIcon,
	LocalAtm as LocalAtmIcon,
	Receipt as ReceiptIcon,
	BusinessCenter as BusinessCenterIcon,
	Description as DescriptionIcon,
	Book as BookIcon,
	Create as CreateIcon,
	LibraryBooks as LibraryBooksIcon,
	Category as CategoryIcon,
	EmojiTransportation,
	People,
	TrackChangesTwoTone,
	Book,
	YoutubeSearchedFor,
} from '@material-ui/icons'
import { MB_ROLES, strings } from '@constants'
import paths from '../paths'

// const collectionStatus = Object.keys(COLLECTION_STATUS)

const adminMenu = (orgRole) => {
	const isLogisticsAdminRole = orgRole === MB_ROLES.LOGISTICS_ADMIN

	// logistics admins get no dashboard (not even the leaderboard); they land on Active Enquiries
	const sideMenuItems = isLogisticsAdminRole ? [] : [{ title: strings('dashboard'), icon: <HomeIcon />, href: paths.admin }]

	if (!isLogisticsAdminRole) {
		sideMenuItems.push({ title: strings('approvals'), icon: <FactCheckIcon />, href: paths.admin_approval_metrics })
	}

	// organisations is not available to tools and tenderbook admins
	const organisationsMenuItem = { title: strings('organisations'), icon: <BusinessIcon />, href: paths.admin_organisations }

	if (![MB_ROLES.TOOLS, MB_ROLES.FINANCE, MB_ROLES.OPERATION, MB_ROLES.TENDERBOOK_ADMIN].includes(orgRole)) {
		sideMenuItems.push(
			{
				title: strings('enquiry'),
				submenu: [
					...(![MB_ROLES.SUPPLY, MB_ROLES.LOGISTICS_ADMIN].includes(orgRole)
						? [{ title: strings('create_enquiry'), href: paths.admin_create_enquiry, icon: <CreateIcon /> }]
						: []),
					// { title: strings('punch_order'), href: paths.admin_punch_order, icon: <ShoppingCart /> },
					{ title: strings('manage_enquiries'), href: paths.admin_manage_enquiry, icon: <ShoppingCart /> },
					{ title: strings('manage_enquiry_orders'), href: paths.admin_manage_enquiry_orders, icon: <StorefrontIcon /> },
					...(![MB_ROLES.SALES, MB_ROLES.LOGISTICS_ADMIN].includes(orgRole)
						? [
								{
									title: strings(['manage', 'spo']),
									href: paths.admin_manage_spo,
									icon: <ReceiptIcon />,
								},
						  ]
						: []),
					{ title: strings('dispatch_plan'), icon: <EmojiTransportation />, href: paths.admin_dispatch_plan },
				],
			},

			organisationsMenuItem
			// { title: strings('admins'), icon: <FaceIcon />, href: paths.admin_view_admins }
		)
	}

	if ([MB_ROLES.OPERATION].includes(orgRole)) {
		sideMenuItems.push({
			title: strings('enquiry'),
			submenu: [
				{ title: strings('manage_enquiries'), href: paths.admin_manage_enquiry_all_create_order, icon: <ListAlt /> },
				{ title: strings('manage_enquiry_orders'), href: paths.admin_manage_enquiry_orders, icon: <Settings /> },
				{
					title: strings(['manage', 'spo']),
					href: paths.admin_manage_spo,
					icon: <ShoppingCart />,
				},
				{ title: strings('dispatch_plan'), icon: <EmojiTransportation />, href: paths.admin_dispatch_plan },
			],
		})
	}

	if ([MB_ROLES.FINANCE, MB_ROLES.OPERATION].includes(orgRole)) {
		sideMenuItems.push(organisationsMenuItem)
	}
	if ([MB_ROLES.SUPER_ADMIN].includes(orgRole)) {
		sideMenuItems.push({ title: strings('admins'), icon: <FaceIcon />, href: paths.admin_view_admins })
	}
	if ([MB_ROLES.SALES, MB_ROLES.SUPPLY, MB_ROLES.ADMIN, MB_ROLES.SUPER_ADMIN, MB_ROLES.FINANCE, MB_ROLES.LOGISTICS_ADMIN].includes(orgRole)) {
		sideMenuItems.push({ title: strings('leads'), icon: <AssignmentIcon />, href: paths.admin_lead_all })
	}
	if ([MB_ROLES.ADMIN, MB_ROLES.SUPER_ADMIN, MB_ROLES.FINANCE].includes(orgRole)) {
		sideMenuItems.push({ title: strings('underwriting'), icon: <BusinessCenterIcon />, href: paths.admin_underwriting })
	}

	if ([MB_ROLES.ADMIN, MB_ROLES.SUPER_ADMIN, MB_ROLES.FINANCE, MB_ROLES.SALES, MB_ROLES.SUPPLY].includes(orgRole)) {
		sideMenuItems.push({ title: strings('ledgers'), href: paths.admin_ledger, icon: <AccountBalanceWalletIcon /> })
	}

	if ([MB_ROLES.ADMIN, MB_ROLES.SUPER_ADMIN].includes(orgRole)) {
	}

	if ([MB_ROLES.ADMIN, MB_ROLES.SUPER_ADMIN].includes(orgRole)) {
		sideMenuItems.push(
			{ title: strings('catalog'), icon: <CategoryIcon />, href: paths.admin_catalog },
			{ title: strings('content'), icon: <BookIcon />, href: paths.admin_content },
			{ title: strings('logistics'), icon: <LocalShippingIcon />, href: paths.admin_logistics_quote_all }
		)
	}

	if (![MB_ROLES.TOOLS, MB_ROLES.FINANCE, MB_ROLES.OPERATION, MB_ROLES.TENDERBOOK_ADMIN, MB_ROLES.LOGISTICS_ADMIN].includes(orgRole)) {
		sideMenuItems.push({ title: strings('commodity', 'prices'), icon: <LocalAtmIcon />, href: paths.admin_commodity_prices })
	}

	if (![MB_ROLES.FINANCE, MB_ROLES.OPERATION, MB_ROLES.TENDERBOOK_ADMIN].includes(orgRole)) {
		sideMenuItems.push({ title: strings('tools'), icon: <Build />, href: paths.admin_tools })
	}

	if (![MB_ROLES.TENDERBOOK_ADMIN].includes(orgRole)) {
		sideMenuItems.push({ title: strings('reports'), icon: <AssessmentIcon />, href: paths.admin_reports })
		sideMenuItems.push({ title: strings('mb_documents'), icon: <DescriptionIcon />, href: paths.mbDocuments })
	}

	if ([MB_ROLES.TENDERBOOK_ADMIN, MB_ROLES.SUPER_ADMIN].includes(orgRole)) {
		sideMenuItems.push({
			title: strings('tenderbook'),
			submenu: [
				{ title: strings('users'), href: paths.tenderbook_user_list, icon: <People /> },
				{ title: strings('leads', 'list'), href: paths.tenderbook_leads_list, icon: <TrackChangesTwoTone /> },
				{ title: strings('tender_master'), href: paths.tenderbook_tender_master, icon: <Book /> },
				{ title: strings('companies'), href: paths.tenderbook_tender_bidder_search, icon: <YoutubeSearchedFor /> },
			],
		})
	}

	if ([MB_ROLES.ADMIN].includes(orgRole)) {
		// useless options
		sideMenuItems.push(
			{
				title: strings('auction'),
				submenu: [
					{
						title: strings('create_auction'),
						href: paths.admin_create_auction,
						icon: <LocalOfferIcon />,
					},
					{
						title: strings('manage_auctions'),
						href: paths.admin_manage_auction,
						icon: <ListAlt />,
					},
					{
						title: strings('manage_auction_orders'),
						href: paths.admin_manage_auction_orders,
						icon: <LibraryBooksIcon />,
					},
				],
			},
			{ title: strings('supplier_by_inventory'), icon: <AssignmentIcon />, href: paths.admin_list_inventory },
			{ title: strings('cloud_factory'), icon: <HomeWorkIcon />, href: paths.admin_cloud_factory },
			{ title: strings('bills'), icon: <ReceiptIcon />, href: paths.admin_bills }
		)
	}

	return sideMenuItems
}

export default adminMenu
